import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import AlertMsg from '../AlertMsg';
import MultiSelect from '../MultiSelect';

import { editDashboards } from '../../redux/actions/dashboards';
import { getAllDevices } from '../../redux/actions/devices';
import { getAllUsers } from '../../redux/actions/users';
import { getAllNetworksGroup } from '../../redux/actions/networksGroup';

function ModalHideItemsDash (props) {
  const {
    showHideItemsTable,
    setShowHideItemsTable,
    currentDash,
    editingPanel
  } = props;
  const INITIAL_VALUES_MULTISELECT = {
    extensions: [],
    groups: [],
    users: [],
    networksGroup: []
  };
  const INITIAL_VALUE = {
    name: '',
    members: [],
    typeDisplay: 'ALL'
  };
  const sortable = (a, b) => {
    return a.sortValue.localeCompare(b.sortValue, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  };
  const txtNamePanel = useRef();
  const dispatch = useDispatch();
  const dashboards = useSelector(state => state.dashboards);
  const devices = useSelector(state => state.devices.data);
  const usersData = useSelector(state => state.users.data);
  const networksGroupData = useSelector(state => state.networksGroup.data);
  const [selectedOptions, setSelectedOptions] = useState({
    ...INITIAL_VALUES_MULTISELECT
  });
  const [extensions, setExtensions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [networksGroup, setNetworksGroup] = useState([]);
  const [data, setData] = useState({ ...INITIAL_VALUE });
  const handleClose = () => {
    setSelectedOptions({ ...INITIAL_VALUES_MULTISELECT });
    setShowHideItemsTable(false);
  };
  const onEnter = () => {
    setData({ ...INITIAL_VALUE, ...editingPanel });
  };

  useEffect(() => {
    dispatch(getAllDevices());
    dispatch(getAllUsers());
    dispatch(getAllNetworksGroup());
  }, [dispatch]);

  const handleClickSaveConfigGlobal = () => {
    const dash = {
      ...currentDash,
      items: currentDash.items.map(item =>
        item.i !== data.i ? { ...item } : { ...data }
      )
    };
    if (data.name) {
      dispatch(editDashboards(dash));
    } else {
      txtNamePanel.current.focus();
    }
  };

  useEffect(() => {
    // Esse Effect garante que após remover um ou mais itens
    // do multiselect os demais permaneçam no lugar correto
    if (editingPanel && editingPanel.type === 'TC') {
      const options = extensions.filter(item =>
        data.members.includes(item.value)
      );
      setSelectedOptions({ ...selectedOptions, extensions: options });
    } else if (
      editingPanel &&
      ['TG', 'GG', 'GGH', 'GGHP', 'GQ'].includes(editingPanel.type)
    ) {
      const options = groups.filter(item => data.members.includes(item.value));
      setSelectedOptions({ ...selectedOptions, groups: options });
    } else if (editingPanel && editingPanel.type === 'TU') {
      const options = users.filter(item => data.members.includes(item.value));
      setSelectedOptions({ ...selectedOptions, users: options });
    } else if (editingPanel && ['TON', 'GON'].includes(editingPanel.type)) {
      const options = networksGroup.filter(item =>
        data.members.includes(item.value)
      );
      setSelectedOptions({ ...selectedOptions, networksGroup: options });
    }
  }, [data]);

  useEffect(() => {
    if (devices.length && showHideItemsTable) {
      const extensions = devices
        .filter(device => device.type === 'E')
        .map(device => ({
          sortValue: `${device.number}`,
          value: `${device.number}`,
          text: `${device.number} - Dpto: ${device.department.name}`
        }))
        .sort(sortable);
      setExtensions([...extensions]);

      const groups = devices
        .filter(device => device.type === 'G')
        .map(device => ({
          sortValue: `${device.number}`,
          value: device._id,
          text: `${device.number} | ${device.name} - Dpto: ${device.department.name}`
        }))
        .sort(sortable);
      setGroups([...groups]);
    }
  }, [devices, setExtensions, setGroups, showHideItemsTable]);

  useEffect(() => {
    if (usersData.length && showHideItemsTable) {
      const usrs = usersData
        .map(user => ({
          sortValue: `${user.name}`,
          value: user._id,
          text: `${user.name} - Dpto: ${user.department.name}`
        }))
        .sort(sortable);
      setUsers([...usrs]);
    }
  }, [usersData, setUsers, showHideItemsTable]);

  useEffect(() => {
    if (networksGroupData.length && showHideItemsTable) {
      const networksGrp = networksGroupData
        .map(networksGroup => ({
          sortValue: `${networksGroup.name}`,
          value: networksGroup._id,
          text: `${networksGroup.name} - Dpto: ${networksGroup.department.name}`
        }))
        .sort(sortable);
      setNetworksGroup([...networksGrp]);
    }
  }, [networksGroupData, setNetworksGroup, showHideItemsTable]);

  const handleMultiDeselect = (deselecteds, nameField) => {
    const options = selectedOptions[nameField].slice();
    deselecteds.forEach(option => options.splice(options.indexOf(option), 1));
    setSelectedOptions({ ...selectedOptions, [nameField]: options });
    const values = options.map(opt => opt.value);
    setData({ ...data, members: values });
  };

  const handleMultiSelect = (selecteds, nameField) => {
    const options = selecteds.slice();
    options.sort(sortable);
    setSelectedOptions({ ...selectedOptions, [nameField]: options });
    const values = options.map(opt => opt.value);
    setData({ ...data, members: values });
  };

  return (
    <div>
      <Modal
        size="lg"
        show={showHideItemsTable}
        onEnter={onEnter}
        onHide={() => setShowHideItemsTable(false)}
        onExited={handleClose}
        dialogClassName="modal-auto-width"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Body className="modal-body-responsive pb-1">
          {dashboards.editSuccess && (
            <AlertMsg type="success" msg="Painel atualizada com sucesso" />
          )}
          {dashboards.editError && (
            <AlertMsg type="danger" msg="Falha durante atualização do painel" />
          )}
          {!dashboards.editSuccess && !dashboards.editError && (
            <AlertMsg
              type="info"
              msg="Área configuração de exibição dos registros no painel"
            />
          )}
          <h3 className="mb-2 ml-2">
            {editingPanel && editingPanel.type}:{' '}
            <span className="badge badge-dark">
              {editingPanel && editingPanel.name}
            </span>
          </h3>
          <div className="ml-2 mr-2">
            <div className="form-group">
              <label htmlFor="name">Nome do painel</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                autoComplete="off"
                onChange={evt =>
                  setData({ ...data, [evt.target.name]: evt.target.value })
                }
                value={data.name}
                ref={txtNamePanel}
              />
            </div>
            <div className="form-group">
              <label htmlFor="typeDisplay">Tipo de exibição</label>
              <select
                className="form-control"
                id="typeDisplay"
                name="typeDisplay"
                value={data.typeDisplay}
                onChange={evt =>
                  setData({ ...data, [evt.target.name]: evt.target.value })
                }
              >
                <option value="ALL">Todos os registros</option>
                <option value="LIST">Selecionar na lista</option>
              </select>
            </div>
            {data.typeDisplay !== 'ALL' && (
              <React.Fragment>
                {editingPanel && editingPanel.type === 'TC' && (
                  <MultiSelect
                    avaliableOptions={extensions}
                    selectedOptions={extensions.filter(item =>
                      data.members.includes(item.value)
                    )}
                    handleMultiDeselect={options =>
                      handleMultiDeselect(options, 'extensions')
                    }
                    handleMultiSelect={options =>
                      handleMultiSelect(options, 'extensions')
                    }
                    valueProp="value"
                    textProp="text"
                    title="Selecione os ramais que serão exibidos no painel"
                    name="extensions"
                  />
                )}
                {editingPanel &&
                  ['TG', 'GG', 'GGH', 'GGHP', 'GQ'].includes(
                    editingPanel.type
                  ) && (
                  <MultiSelect
                    avaliableOptions={groups}
                    selectedOptions={groups.filter(item =>
                      data.members.includes(item.value)
                    )}
                    handleMultiDeselect={options =>
                      handleMultiDeselect(options, 'groups')
                    }
                    handleMultiSelect={options =>
                      handleMultiSelect(options, 'groups')
                    }
                    valueProp="value"
                    textProp="text"
                    title="Selecione os grupos que serão exibidos no painel"
                    name="groups"
                  />
                )}
                {editingPanel && editingPanel.type === 'TU' && (
                  <MultiSelect
                    avaliableOptions={users}
                    selectedOptions={users.filter(item =>
                      data.members.includes(item.value)
                    )}
                    handleMultiDeselect={options =>
                      handleMultiDeselect(options, 'users')
                    }
                    handleMultiSelect={options =>
                      handleMultiSelect(options, 'users')
                    }
                    valueProp="value"
                    textProp="text"
                    title="Selecione os usuários que serão exibidos no painel"
                    name="users"
                  />
                )}
                {editingPanel && ['TON', 'GON'].includes(editingPanel.type) && (
                  <MultiSelect
                    avaliableOptions={networksGroup}
                    selectedOptions={networksGroup.filter(item =>
                      data.members.includes(item.value)
                    )}
                    handleMultiDeselect={options =>
                      handleMultiDeselect(options, 'networksGroup')
                    }
                    handleMultiSelect={options =>
                      handleMultiSelect(options, 'networksGroup')
                    }
                    valueProp="value"
                    textProp="text"
                    title="Selecione os grupos de tronco que serão exibidos no painel"
                    name="networksGroup"
                  />
                )}
              </React.Fragment>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            <span>
              <i className="fas fa-times" /> Fechar
            </span>
          </Button>
          <Button
            variant="primary"
            onClick={handleClickSaveConfigGlobal}
            disabled={dashboards.isFetching}
          >
            <span>
              <i className="fas fa-save" /> Salvar
            </span>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

ModalHideItemsDash.propTypes = {
  showHideItemsTable: PropTypes.bool,
  setShowHideItemsTable: PropTypes.func,
  currentDash: PropTypes.object,
  editingPanel: PropTypes.object
};

export default ModalHideItemsDash;
